import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthViewEnum } from '../../enums/auth-step-enum';
import { IUserNameFormOutput } from '@app/auth/models/username-form-output-model';
import { RegexList } from 'constants/regex';
import { userNameValidator } from '../../validators/username-validator';
import { ForgetFlowStepEnum } from '../../enums/forget-flow-step-enum';
import { OtpInputComponent } from '@shared/components/otp-input/otp-input.component';
import { passwordMatchValidator } from '../../validators/password-match-validator';
import { NgClass } from '@angular/common';
import { ForgetPasswordModel } from '@shared/model/forgetPassword-model';
import { StandardNumberDirective } from '@shared/utils/standard-number.directive';
import { ButtonLoaderDirective } from '@shared/directive/button-loader/button-loader.directive';

@Component({
    selector: 'app-forget-password-presenter',
    imports: [
        ReactiveFormsModule,
        OtpInputComponent,
        NgClass,
        ButtonLoaderDirective,
        StandardNumberDirective
    ],
    templateUrl: './forget-password-presenter.component.html',
    styleUrl: './forget-password-presenter.component.scss'
})
export class ForgetPasswordPresenterComponent implements OnInit {
  private fb = inject(FormBuilder);


  @Input() submitUsernameLoading = false;
  @Input() verificationLoading = false;
  @Input() confirmPasswordLoading = false;
  @Input() step: ForgetFlowStepEnum = ForgetFlowStepEnum.userName;
  @Input() verificationCode: number | null = null;
  @Output() onOtpDesired = new EventEmitter<AuthViewEnum>();
  @Output() onUserNameSubmitted = new EventEmitter<IUserNameFormOutput>();
  @Output() onResetAuthFlow = new EventEmitter<void>();
  @Output() onCodeChanged = new EventEmitter<string>();
  @Output() onNewPasswordSubmitted = new EventEmitter<ForgetPasswordModel>();



  forgetFlowStepEnum = ForgetFlowStepEnum;
  usernameForm!: FormGroup;
  newPasswordForm!: FormGroup;
  initialData!: IUserNameFormOutput;
  code = '';
  passwordVisible = false;
  repeatPasswordVisible = false;


  ngOnInit(): void {
    this.initUsernameForm();
    this.initNewPasswordForm();
  }

  initUsernameForm() {
    this.usernameForm = this.fb.group({
      username: new FormControl(null, [Validators.required, userNameValidator()])
    });
  }

  initNewPasswordForm() {
    this.newPasswordForm = this.fb.group({
      password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
      pass_repeat: new FormControl(null, [Validators.required, Validators.minLength(6)])
    }, { validators: passwordMatchValidator });
  }

  submitUsername() {
    const userName = this.usernameForm.get('username')?.value;
    const isEmail = RegexList.email.test(userName);
    const output: IUserNameFormOutput = {
      userName,
      type: isEmail ? 'email' : 'phone'
    };
    this.initialData = output;
    this.onUserNameSubmitted.emit(output);
  }

  verifyCode(code?: string) {
    if (code)
      this.code = code;
    if (this.code && this.code?.length == 4) {
      this.onCodeChanged.emit(this.code);
    }
  }

  submitNewPassword() {
    const data: ForgetPasswordModel = new ForgetPasswordModel();
    data.code = this.code;
    data.password = this.newPasswordForm.get('password')?.value;
    data.confirmPassword = this.newPasswordForm.get('pass_repeat')?.value;
    if(this.initialData.type == 'email')
      data.email = this.initialData.userName;
    else
      data.phoneNumber = this.initialData.userName;
    this.onNewPasswordSubmitted.emit(data);
  }

  loginWithOtp() {
    this.onOtpDesired.emit(AuthViewEnum.userName);
  }

  changeUserName() {
    this.onResetAuthFlow.emit();
  }


}
